/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { trackEvent } from '../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';
import useClickStreamCustomEventsTracking from '../../../helpers/Personalization/useClickstreamCustomEventsTracking';

export default function universalHandleClick(salesforceResponse) {
    const dispatch = useDispatch();
    const history = useHistory();
    const trackClickThrough = useClickStreamCustomEventsTracking({
        salesforceResponse,
        isFireImpression: salesforceResponse?.campaign,
        page: { type: 'home' },
    });
    const handleClick = (item, gaConstants = {}) => {
        const path = item?.link?.href;
        const title = item?.link?.title;

        // If no path and no title, don't trigger the click event
        if (!path && !title) {
            return;
        }

        dispatch(trackEvent({
            eventCategory: item?.tracking_event_category ||  gaConstants?.tracking_event_category || '',
            eventAction: item?.tracking_event_action ||  gaConstants?.tracking_event_action || '',
            eventLabel: item?.tracking_event_label || '',
        }));
        if (path?.includes('://')) {
            window.location.href = path;
        } else {
            history.push(path);
        }
        trackClickThrough();
    };
    return handleClick;
}
